module.exports = __webpack_public_path__ + "static/media/typeA.e6ea83fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/selfcare/typeA.png
// module id = 1253
// module chunks = 0